// curatedStore.ts
import { defineStore } from "pinia";
import { ref } from "vue";
import * as CmsService from "../services/cms.service";

export const useCuratedStore = defineStore('curatedStore', () => {
    const curatedOffers = ref([]);
    const loadingCurated = ref(false);

    function fetchCuratedOffers() {
        loadingCurated.value = true;
        CmsService.getCuratedOffers()
            .then((response) => {
                curatedOffers.value = response.data;
            })
            .catch((error) => {
                console.error("Error fetching curated offers:", error);
                curatedOffers.value = [];
            })
            .finally(() => {
                loadingCurated.value = false;
            });
    }

    return {
        curatedOffers,
        loadingCurated,
        fetchCuratedOffers
    };
});